// extracted by mini-css-extract-plugin
export default {"searchInput__root":"SearchInput_searchInput__root__Md1DQ","searchInput__btn":"SearchInput_searchInput__btn__zHF40"};